import { render, staticRenderFns } from "./AnaliseProdutoNaoComercializados.vue?vue&type=template&id=6be7320e&scoped=true&"
import script from "./AnaliseProdutoNaoComercializados.vue?vue&type=script&lang=js&"
export * from "./AnaliseProdutoNaoComercializados.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseProdutoNaoComercializados.vue?vue&type=style&index=0&id=6be7320e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be7320e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
